import { styled } from 'styled-components';

export const Container = styled.div`
    width: 100%;
    box-sizing: border-box;
    background-color: #fff;
    border-radius: 16px;
    min-width: 282px;
    padding: 16px;

    h1 {
        font-weight: 600;
        color: #1a1a1a;
        font-size: 18px;
        padding: 16px 0 16px;
    }
`;

export const InputContainer = styled.div`
  padding-bottom: 20px;
`;

export const NotePayment = styled.div`
  display: flex;
  width: 100%;
  box-sizing: border-box;
  border-radius: 6px;
  padding: 16px;
  margin-bottom: 15px;

  > .material-icons {
    font-size: 40px;
    color: #2dace3;
    margin-top: 3px;
    margin-right: 10px;
  }

  h1 {
    font-weight: 600;
    color: #1A1A1A;
    margin: 0;
    max-width: 100%;
    word-break: break-word;
    font-size: 16px;
  }

  p {
    font-weight: 400;
    margin-top: 0;
    font-size: 14px;
  }
`;